import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var WarningAlt = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.925 40.009 22.937 3.729c-.2-.3-.5-.5-.9-.5s-.7.2-.899.5L.15 40.01c-.2.3-.2.7 0 .999.2.4.6.6.9.6h41.976c.4 0 .7-.2.899-.5.1-.4.1-.8 0-1.1Zm-40.977-.5 19.09-33.081 19.089 33.08H2.948Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.038 13.823c.6 0 1.099.5 1.099 1.1v15.391c0 .6-.5 1.1-1.1 1.1-.6 0-1.099-.5-1.099-1.1V14.823c0-.6.5-1 1.1-1ZM23.936 35.411c0 1.1-.9 1.9-1.898 1.9-1 0-1.9-.9-1.9-1.9 0-1 .9-1.899 1.9-1.899.999 0 1.898.9 1.898 1.9Z"
  }));
});
WarningAlt.displayName = 'WarningAlt';
WarningAlt.defaultProps = {
  'aria-label': 'WarningAlt'
};
export default WarningAlt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/WarningAlt.js
// module id = 3325
// module chunks = 11